<template>

   <!-- tttm-pf-single-related-wrapper -->
                        <div class="row ttm-pf-single-related-wrapper ttm-boxes-row-wrapper">
                            <div class="col-lg-12">
                                <h3 class="ttm-pf-single-related-title">Related Projects</h3>
                            </div>
                            <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                                            <!-- featured-imagebox -->
                                            <div class="featured-imagebox featured-imagebox-portfolio ttm-box-view-top-image">
                                                <div class="ttm-box-view-content-inner">
                                                    <!-- featured-thumbnail -->
                                                    <div class="featured-thumbnail">
                                                        <a href="#"> <img class="img-fluid" src="/img/fish.png" alt="image"></a>
                                                    </div><!-- featured-thumbnail end-->
                                                </div>
                                                <div class="ttm-box-bottom-content featured-content-portfolio box-shadow">
                                                    <div class="featured-title">
                                                       <h5><router-link to="/fishery-subscription" tag="a"> Fishery Subscription </router-link></h5>
                                                    </div>
                                                    <span class="category">
                                                        <a href="#">As low as ,</a>
                                                        <a href="#"> N247,999</a>
                                                    </span>
                                                </div>
                                            </div><!-- featured-imagebox -->
                                        </div>
                            <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                                            <!-- featured-imagebox -->
                                            <div class="featured-imagebox featured-imagebox-portfolio ttm-box-view-top-image">
                                                <div class="ttm-box-view-content-inner">
                                                    <!-- featured-thumbnail -->
                                                    <div class="featured-thumbnail">
                                                        <a href="#"> <img class="img-fluid" src="/img/oil.png" alt="image"></a>
                                                    </div><!-- featured-thumbnail end-->
                                                    </div>
                                                <div class="ttm-box-bottom-content featured-content-portfolio box-shadow">
                                                    <div class="featured-title">
                                                        <h5><router-link to="/cashcrop-subscription" tag="a"> CashCrop Subscription </router-link></h5>
                                                    </div>
                                                    <span class="category">
                                                        <a href="#">As low as ,</a>
                                                        <a href="#"> N457,000</a>
                                                    </span>
                                                </div>
                                            </div><!-- featured-imagebox -->
                                        </div>
                            <div class="ttm-box-col-wrapper col-lg-4 col-md-4 col-sm-6">
                                <!-- featured-imagebox -->
                                <div class="featured-imagebox featured-imagebox-portfolio ttm-box-view-top-image">
                                    <div class="ttm-box-view-content-inner">
                                        <!-- featured-thumbnail -->
                                        <div class="featured-thumbnail">
                                            <a href="#"> <img class="img-fluid" src="/img/es.png" alt="image"></a>
                                        </div><!-- featured-thumbnail end -->
                                        
                                    </div>
                                    <div class="ttm-box-bottom-content featured-content-portfolio box-shadow">
                                        <div class="featured-title">
                                           <h5><router-link to="/farmland-subscription" tag="a"> Farmland Subscription </router-link></h5>
                                        </div>
                                        <span class="category">
                                           <a href="#">As low as , </a>
                                          <a href="#">N457,000</a>
                                        </span>
                                    </div>
                                </div><!-- featured-imagebox -->
                            </div>
                        </div>
                        <!-- tttm-pf-single-related-wrapper end-->
  
</template>

<script>
export default {
  name: "RelatedPortfolio",
  props: {}
};
</script>


<style scoped>



</style>




